import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BackButtonService {

  constructor(
    private location: Location,
    private router: Router
  ) {}

  /** Simple browser back */
  goBack(): void {
    this.location.back();
  }

  /** Go back or fallback to a route if no history */
  goBackOrFallback(fallbackRoute: string): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate([fallbackRoute]);
    }
  }

  /** Go back N steps */
  goBackSteps(steps: number = 1): void {
    window.history.go(-steps);
  }
}